import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {StorageProperties} from './local-storage.service';

export type TextSize = 'small' | 'normal' | 'large';

const SIZE_TO_PX: Record<TextSize, string> = {
  small: '16px',
  normal: '18px',
  large: '20px',
};

const CSS_CLASSES: Record<TextSize, string> = {
  small: 'text-small',
  normal: 'text-normal',
  large: 'text-large',
};

@Injectable({
  providedIn: 'root'
})
export class TextSizeService {

  currentSize$ = new BehaviorSubject<TextSize>('normal');

  async init(): Promise<void> {
    const value = localStorage.getItem(StorageProperties.TEXT_SIZE);
    const size: TextSize = this.isValidSize(value) ? value : 'normal';
    this.applySize(size);
  }

  async setSize(size: TextSize): Promise<void> {
    localStorage.setItem(StorageProperties.TEXT_SIZE, size);
    this.applySize(size);
  }

  private applySize(size: TextSize): void {
    const html = document.documentElement;
    Object.values(CSS_CLASSES).forEach(cls => html.classList.remove(cls));
    html.classList.add(CSS_CLASSES[size]);
    html.style.fontSize = SIZE_TO_PX[size];
    this.currentSize$.next(size);
  }

  private isValidSize(value: string | null): value is TextSize {
    return value === 'small' || value === 'normal' || value === 'large';
  }
}
